import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { InternationalizationService } from '@examdojo/core/i18n';
import { IconComponent } from '@examdojo/core/icon';
import { SelectionListComponent } from '../selection-list/selection-list.component';
import { TopicCodeNumberComponent } from '../topic-code-number/topic-code-number.component';

@Component({
  selector: 'dojo-selection-cards',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, ReactiveFormsModule, IconComponent, TopicCodeNumberComponent],
  styleUrls: ['./selection-cards.component.scss'],
  host: {
    '[class.hide-checkbox]': '!showCheckbox()',
  },
  template: `
    <mat-selection-list
      class="custom-selection-list-checkbox"
      [formControl]="formCtrl()"
      (selectionChange)="optionSelected.emit($event.options)"
      [multiple]="multiple()"
      [compareWith]="compareWith() ?? defaultCompareWith"
    >
      @for (option of state.options; track option.value; let idx = $index) {
        <mat-list-option
          [value]="option.value"
          class="relative"
          [class.hide-indicator]="hideIndicator()"
          [disabled]="option.disabled === true"
        >
          @if (option.cornerTag) {
            <div
              class="text-neutral-0 absolute right-[10px] top-[10px] rounded-[6px] bg-sky-500 px-1 text-xs font-semibold"
            >
              {{ option.cornerTag }}
            </div>
          }
          <div class="flex flex-col items-center gap-2">
            @if (option.figure) {
              @switch (option.figure.type) {
                @case ('icon') {
                  <dojo-icon [icon]="option.figure.icon" [alt]="option.label" [size]="figureIconSize()" />
                }
                @case ('label') {
                  <dojo-topic-code-number [codeNumber]="option.figure.label" />
                }
              }
            }

            <div class="flex flex-col items-center gap-1">
              <span class="selection-label text-primary text-wrap text-center">
                @if (labelsAreTranslationKeys()) {
                  {{ option.label }}
                } @else {
                  {{ option.label }}
                }
              </span>

              @if (option?.labelDescription) {
                <span class="text-secondary text-wrap text-center font-normal">
                  {{ option.labelDescription }}
                </span>
              }
            </div>
          </div>
        </mat-list-option>
      }
    </mat-selection-list>
  `,
})
export class SelectionCardsComponent<T = unknown> extends SelectionListComponent<T> {
  constructor(internationalizationService: InternationalizationService) {
    super(internationalizationService);
  }

  readonly showCheckbox = input(false);
}
